import React, { useState } from 'react';

import { filterByPropertyPartialValue } from 'utilities/collection';

import SimpleDialog from 'generics/components/simple-dialog';
import SimpleSearchControl from 'generics/components/simple-search-control';

import { ReactComponent as SmallCloseIcon } from 'assets/images/small-close-icon.svg';

import './index.scss';

function MeetingAttendeesList(props) {

  const { attendees, onClose } = props;

  const [rootState, setRootState] = useState({
    attendees: attendees,
    filteredAttendees: attendees
  });

  function filterAttendees(searchText) {

    setRootState(function updateRootState(rootState) {

      const filteredAttendees = filterByPropertyPartialValue(rootState.attendees, 'fullName', searchText);

      return {
        ...rootState,
        filteredAttendees
      };

    });

  }

  function renderHeader() {

    const meetingAttendeesListDialogCloseButtonAttributes = {
      type: 'button',
      className: 'meeting-attendees-list-close-button',
      onClick() {
        onClose();
      }
    };

    return <div id="meeting-attendees-list-header">
      <label id="meeting-attendees-list-label">Attendees</label>
      <button {...meetingAttendeesListDialogCloseButtonAttributes}>
        <SmallCloseIcon className="meeting-attendees-close-control-icon" />
      </button>
    </div>;

  }

  function renderSearchBox() {

    const attendeesSearchControlProperties = {
      placeholder: 'Search for attendees',
      onChange(searchText) {
        filterAttendees(searchText);
      }
    };

    return <SimpleSearchControl {...attendeesSearchControlProperties} />;

  }

  function renderAttendee(attendee, index) {

    let hostLabel = '';

    if (attendee.host === true) {
      hostLabel = '(Host)';
    }

    const entryAttributes = {
      className: 'meeting-attendee'
    };

    const attendeeProfilePictureAttributes = {
      className: 'meeting-attendee-profile-picture',
      style: {
        backgroundImage: `url(${attendee.profilePicture.url})`
      }
    };

    return <li key={index} {...entryAttributes}>
      <div {...attendeeProfilePictureAttributes}></div>
      <label className="attendee-full-name-label">{attendee.fullName} {hostLabel}</label>
    </li>;

  }

  function renderAttendees() {

    const attendees = rootState.filteredAttendees;
    const elements = [];
    const attendeesLength = attendees.length;

    for (let index = 0; index < attendeesLength; index++) {

      const attendee = attendees[index];
      const element = renderAttendee(attendee, index);

      elements.push(element);

    }

    return <ul id="meeting-attendees-content-list" className="helptap-list hide-scrollbar">{elements}</ul>;

  }

  function renderMain() {

    const dialogProperties = {
      stackTopClass: 'async-dialog',
      contentHolderClassName: 'meeting-attendees-list-display-holder',
      onClose() {
        onClose();
      }
    };

    return <SimpleDialog {...dialogProperties}>
      <div id="meeting-attendees-list-main">
        {renderHeader()}
        {renderSearchBox()}
        {renderAttendees()}
      </div>
    </SimpleDialog>;

  }

  return renderMain();

}

export default MeetingAttendeesList;